import { ConfirmationDialogueComponent } from '@/app/components/global/dialog-boxes/confirmation-dialogue/confirmation-dialogue.component';
import { ModalConfigratoinData } from '@/app/components/global/modal-configration-data.json';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AppHeaderComponent } from "../../../../../global/appHeader/appHeader.component";

@Component({
  selector: 'app-selected-drawing-review',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, MatIconModule, ReactiveFormsModule, AppHeaderComponent],
  templateUrl: './selected-drawing-review.component.html',
  styleUrl: './selected-drawing-review.component.css'
})
export class SelectedDrawingReviewComponent {

  Drawing_Confirmation =
    ModalConfigratoinData.Drawing_Confirmation;

constructor( private dialog: MatDialog,){

}

  drawingForm = new FormGroup({
    number: new FormControl('S001'),
    discipline: new FormControl('Structural'),
    title: new FormControl('TYPICAL DETAILS'),
  });
 documents = [
  { id: 'S001', status: 'Viewed', category: 'GENERAL STRUCTURE' },
  { id: 'S002', category: 'TYPICAL DETAILS' },
  { id: 'S003', category: 'GENERAL STRUCTURE' },
  { id: 'S003', category: 'GENERAL STRUCTURE' },
  { id: 'S100', category: 'GENERAL STRUCTURE' },
  { id: 'S102', category: 'FRAMING DETAILS' },
  { id: 'S103', category: 'FOUNDATION DETAILS' },
  { id: 'S104', category: 'GENERAL STRUCTURE' },
  { id: 'S104', category: 'GENERAL STRUCTURE' },
  { id: 'S105', category: 'GENERAL STRUCTURE' },
  { id: 'S107', category: 'GENERAL STRUCTURE' },
  { id: 'S108', category: 'GENERAL STRUCTURE' },
  { id: 'S109', category: 'GENERAL STRUCTURE' },
  { id: 'S201', category: 'GENERAL STRUCTURE' },
  { id: 'S201', category: 'GENERAL STRUCTURE' },
];
versions = new FormGroup({
  rows: new FormControl([
    { revision: '1', drawingDate: '15/03/2025', receivedDate: '15/03/2025', set: 'Revision 1' },
    { revision: '0', drawingDate: '15/03/2025', receivedDate: '15/03/2025', set: 'Structural Bid' },
  ]),
});
confirmedCount = 0;
totalDocuments = this.documents.length;

confirmAll() {
  this.confirmedCount = this.totalDocuments;
}
 confirmationDialog() {
    // Opens the dialog
    this.dialog.open(ConfirmationDialogueComponent, {
      width: '30.313rem',
      height: '15.75rem',
      autoFocus: false,
      data: {
        ...this.Drawing_Confirmation,
      },
    });
    // dialogRef.afterClosed().subscribe(() => {
    //   this.activeRowIndex = null; // Reset activeRowIndex to null
    // });
  }

}
